<template>
  <div class="headerDiv fixWhite">
    <!-- :class="scroll ? 'headerDiv fixWhite fixHeader' : 'headerDiv'" -->
    <div class="left">
      <router-link to="/">
        <div class="logo">
          <img :src="logoSrc1" />
        </div>
      </router-link>
      <el-menu
        ref="navMenu"
        :default-active="$route.path"
        mode="horizontal"
        :router="router"
        popper-append-to-body
      >
        <el-menu-item index="/">首页</el-menu-item>
        <el-submenu index="/service" popper-class="subMenuClass">
          <template slot="title"
            ><router-link to="/service/1" style="color: #333"
              >产品服务</router-link
            ></template
          >
          <!-- /ezzloc -->
          <el-menu-item index="/service/1">
            <template slot="title">
              <div class="menu2">
                <img :src="weizhiIcon" alt="" style="border-radius: 10px" />
                <div>
                  <div class="menuTitle">位置助手</div>
                  <div class="menuText">以位置服务为基础的物联网平台</div>
                </div>
              </div>
            </template>
          </el-menu-item>
          <el-menu-item index="/service/2">
            <template slot="title">
              <div class="menu2">
                <img :src="chelianIcon" alt="" />
                <div>
                  <div class="menuTitle">透明车联</div>
                  <div class="menuText">是视频服务为基础的车联网平台</div>
                </div>
              </div>
            </template>
          </el-menu-item>
          <el-menu-item index="/service/3">
            <template slot="title">
              <div class="menu2">
                <img :src="ezzlocIcon" alt="" />
                <div>
                  <div class="menuTitle">Ezzloc</div>
                  <div class="menuText">面向全球用户的位置服务应用平台</div>
                </div>
              </div>
            </template>
          </el-menu-item>
          <el-menu-item index="/service/4">
            <template slot="title">
              <div class="menu2">
                <img :src="shaobingIcon" alt="" />
                <div>
                  <div class="menuTitle">哨冰</div>
                  <div class="menuText">以温度服务为基础的数字化品牌</div>
                </div>
              </div>
            </template>
          </el-menu-item>
          <el-menu-item index="/service/5">
            <template slot="title">
              <div class="menu2">
                <img :src="daovayIcon" alt="" />
                <div>
                  <div class="menuTitle">DAOVAY</div>
                  <div class="menuText">到位科技IOT智能硬件品牌</div>
                </div>
              </div>
            </template>
          </el-menu-item>
        </el-submenu>
        <!-- <el-menu-item index="/ezzloc">方案中心</el-menu-item> -->
        <el-menu-item index="/news">资讯动态</el-menu-item>
        <el-menu-item index="/aboutus">关于到位</el-menu-item>
      </el-menu>
      <div v-if="showMenu" class="showMenu">
        <el-menu
          ref="navMenu"
          :default-active="$route.path"
          mode="horizontal"
          :router="router"
          popper-append-to-body
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/service/1">产品服务</el-menu-item>
          <el-menu-item index="/news">资讯动态</el-menu-item>
          <el-menu-item index="/aboutus">关于到位</el-menu-item>
        </el-menu>
      </div>
      <svg-icon icon-class="menu" class="leaf" @click="showMenuFun(showMenu)" />
    </div>
    <div class="right">
      <img src="../assets/img/tel.png" />
      <a href="https://www.daovay.com/" target="_blank" class="toEn">En</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      showMenu: false,
      router: true,
      language: "en",
      scroll: false,
      swiperTab: 0,
      logoSrc1: require("../assets/img/logo.png"),
      logoSrc2: require("../assets/img/logo2.png"),
      weizhiIcon: require("../assets/img/logo5.png"),
      chelianIcon: require("../assets/img/logo4.png"),
      shaobingIcon: require("../assets/img/logo3.png"),
      daovayIcon: require("../assets/img/logo7.png"),
      ezzlocIcon: require("../assets/img/logo6.png"),
    };
  },
  watch: {
    $route(route) {
      this.showMenu=false;
    }
  },
  created() {
    //this.language = getLocale();
  },
  mounted() {
    window.addEventListener("scroll", this.fixedActiveBtn);
  },
  methods: {
    fixedActiveBtn() {
      const that = this;
      var topScroll = document.documentElement.scrollTop; //滚动的距离,距离顶部的距离
      if (topScroll > 0) {
        //document.documentElement.clientHeight - 120
        //当滚动距离大于页面高度时执行下面的东西
        that.scroll = true;
      } else {
        //当滚动距离小于页面高度的时候执行下面的内容，也就是让导航栏恢复原状
        that.scroll = false;
      }
    },
    showMenuFun(show) {
      if (!show) {
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
    },
  },
};
</script>
<style lang="scss" >
.headerDiv {
  width: 100%;
  // height: 60px;
  padding: 20px 0 11px;
  box-sizing: content-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // background-color: #2e3652;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  transition: all linear 0.5s;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  .left {
    width: 100%;
    position: relative;
    .leaf {
      position: absolute;
      right: 5%;
      display: none;
      cursor: pointer;
    }
  }
  .right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right: 5%;
    img {
      height: 30px;
      margin-right: 20%;
    }
    .toEn {
      display: block;
      padding: 4px 15px;
      border: 1px solid #00bebe;
      color: #00bebe;
      font-size: 14px;
      background-color: rgba(0, 190, 190, 0.1);
    }
  }
  .logo {
    display: flex;
    align-items: center;
    float: left;
    margin-left: 50px;

    img {
      width: auto;
      height: 70px;
      line-height: 60px;
    }

    img:nth-child(1) {
      display: inline-block;
    }

    img:nth-child(2) {
      display: none;
    }
  }

  .el-menu {
    float: left;
    display: flex;
    justify-content: space-between;
    background-color: transparent;
    margin-top: 0px;
    margin-right: 7%;
  }

  .el-menu.el-menu--horizontal {
    border: none;
    width: 50%;
  }

  .el-dropdown {
    margin-right: 30px;
  }

  .blackdropdown {
    color: #000;
  }

  .whitedropdown {
    color: #fff;
  }

  .whiteNav {
    .el-menu-item {
      border: 1px solid #fff;
      border-bottom-color: #fff !important;
    }

    .el-submenu__title {
      border: 1px solid #fff;
      border-bottom: 1px solid #fff !important;
    }

    .el-submenu__title i {
      color: #fff !important;
    }
  }
}
.subMenuClass {
  max-width: 80%;
  .el-menu {
    width: auto !important;
    max-width: 1200px !important;
    flex-wrap: wrap;
    padding: 50px 30px 0 30px !important;
    li {
      width: 32%;
      margin-bottom: 40px;
      margin-right: 1% !important;
    }
  }
}
.darkBack {
  background-color: rgba(64, 64, 64, 0.6);

  .el-dropdown {
    color: #fff;
  }
}

.fixHeader {
  position: fixed;
}

.fixWhite {
  position: fixed;
  background-color: #ffffff;
  box-shadow: 0 0 10px 3px #ededed;

  // box-shadow: 0 0 10px 4px #dcdbdb;
  .el-menu--horizontal > .el-submenu {
    .el-submenu__title {
      color: #333 !important;
      a {
        color: #333 !important;
      }
      &::before {
        background-color: #00bebe;
      }
    }

    &:hover,
    &:focus {
      .el-submenu__title {
        color: #00bebe !important;
      }
      a {
        color: #00bebe !important;
      }
    }
  }

  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    color: #00bebe !important;
  }

  .el-menu--horizontal > .el-menu-item {
    color: #333 !important;

    &::before {
      background-color: #00bebe;
    }

    &:hover,
    &:focus,
    &.is-active {
      color: #00bebe !important;
    }
  }
}

.fixDark {
  position: fixed;
  background-color: rgba(99, 99, 99, 0.623);
  box-shadow: none;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #00c977;
}

// .serHead {
//   .el-submenu__title i {
//     color: #fff !important;
//   }
//   .el-dropdown {
//     color: #fff;
//   }
//   .el-menu-item {
//     border: 1px solid #fff;
//     border-bottom-color: #fff !important;
//     color: #fff;
//   }
// }
@media only screen and (max-width: 767px) {
  .headerDiv {
    background-color: #fff;
    height: 50px;
    .right {
      display: none;
    }
    .left {
      .leaf {
        display: block;
        font-size: 30px;
        top: 3px;
        color: #00bebe;
      }
      .logo {
        width: auto;
        margin-left: 10px;
        img {
          height: 40px;
          line-height: 40px;
        }
      }
      .el-menu {
        display: none;
      }
      .showMenu {
        position: absolute;
        top: 55px;
        width:100%;
        border-top: 1px solid #eee;
        .el-menu {
          width: 100%;
          display: flex;
          background-color: rgba(255, 255, 255,1.438);
        }
        .el-menu--horizontal > .el-menu-item::before{
          bottom: 0%;
        }
        .el-menu--horizontal > .el-submenu .el-submenu__title::before{
          bottom: 0%;
        }
      }
    }

    .menuRight {
      display: none;
      float: right;
      padding-top: 9px;
      margin-right: 10px;

      .el-dropdown {
        font-size: 14px;
        margin-right: 10px;

        img {
          margin-right: 1px;
        }
      }

      a {
        margin-right: 20px;
        color: #333;
        font-size: 13px;
      }

      .login {
        display: none;
      }
    }
  }
}
</style>